export default {
      id: "gear-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#gear-usage",
      toString: function () {
        return this.url;
      }
    }